export const createLoadingSlice = (set) => ({
  loading: false,
  setLoading: (loading) => set(() => ({ loading: loading })),
  clearLoading: () => set(() => ({ loading: false })),
})